import React, { useEffect,  useState } from 'react';
import SliderVideo from '../../../videos';
import SliderImage from '../../../slider';
import { getAreapCook, getProyCook } from '../../../../utils/params';
import { getArchivosDetImg } from '../../../../services/public/archivos';
import Toasts from '../../../toast';

//----------------------------------------------------------------------------------------------------------------------
function Preview() 
{
  const [Archivo, setArchivos] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [opciones, setOpciones] = useState([]);
  const [proyecta, setProyecta] = useState(0);
//----------------------------------------------------------------------------------------------------------------------  
  useEffect(() =>
    {
      const interval = setTimeout(() => 
        {
           handleParamsIni();
        }, 10000 );
        return () => clearTimeout(interval);
    },[]);

//----------------------------------------------------------------------------------------------------------------------
  const handleParamsIni= async() =>
    {
      const AreaId = getAreapCook();
      let ProyectaId = getProyCook(); 
      setProyecta(getProyCook());
    
      if ((ProyectaId ==='1') || (ProyectaId === '2'))
       {
         let Tipo ='IM';
         if (ProyectaId === '2') Tipo='VI'
       
         const response = await getArchivosDetImg(AreaId,Tipo);
         if (response) 
          {
            if (response.status === 200) 
              {
               setArchivos(response.data.data);
              } 
            else 
            {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
           }
        }
    }
  }

  return (
   <>
     <div className="flex  h-[30rem] mt-8 mx-40 bg-light rounded-lg shadow-lg shadow-border-gray-700 border border-stone-200">
      {proyecta === '1' ? (
         (Archivo.length > 0) ?(
           <SliderImage data={Archivo}/>):null)
           :
           proyecta ==='2' ? ((Archivo.length > 0) ?(
            <SliderVideo data={Archivo}/>):null) :null
      }    
     </div>
     {showToast ? (
        <Toasts
          type={opciones.type}
          message={opciones.message}
          active={opciones.active}
        ></Toasts>
      ) : (
          ""
        )}

   </>
  );
}

export default Preview;
